document.addEventListener('DOMContentLoaded', () => {
  window.openQubeMobileMenu = function() {
    const drawer = document.getElementById('qube-mobile-menu');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden'; // prevent bg scroll
    }
  };

  window.closeQubeMobileMenu = function() {
    const drawer = document.getElementById('qube-mobile-menu');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };
});
